import * as m from "mithril";
import { NavBar } from '../../components/NavBar';
import AppContext from '../../context/AppContext';
import './AppPaymentPage.scss';
import buildLanguageChangeActions from "../common/LanguageNavActions";
import TentativeBookingSummary from "../pay/TentativeBookingSummary";
import ModalDialog from "../../components/ModalDialog";
import LoadingIndicator from "../../components/LoadingIndicator";
import { SelectedPaymentModal } from "./SelectedPaymentModal";
import PaymentOptionSelectionList from "./PaymentOptionSelectionList";
import { SelectedPayment } from "../../states/payment-selection/PaymentSelectionFsmContext";
import Either from "../../types/Either";
import { ErrorDTO, OperatorDTO, PaymentOptionDTO, PromoCodeVerifiedResponseDTO, TentativeBookingDTO } from "../../apiclient/ApiDtos";



interface Attrs {
    appContext: AppContext,
    operator: OperatorDTO,
    tentativeBooking: TentativeBookingDTO,
    isLoading: boolean,
    paymentOptions: PaymentOptionDTO[]|null,
    selectedPayment: SelectedPayment|null,
    promoAppliedResult: Either<ErrorDTO, PromoCodeVerifiedResponseDTO> | null,

    onSelectPaymentOption: (paymentOption: PaymentOptionDTO) => void,
    onUnselectPaymentOption: () => void,
    onApplyPromoCode: (promoCode: string) => void,
    onRemovePromoCode: () => void,
    onInitiatePayment: () => void,

    isBacktracking: boolean,
    onBacktrackRequested: () => void,
    onBacktrackCancelled: () => void,
    onBacktrackConfirmed: () => void
}


function PaymentSelectionPage(): m.Component<Attrs> {
    const handlePageShow = (event: Event) => {
        if ((event as PageTransitionEvent).persisted) { 
            console.debug("Backing from payment page.")
            //alert("back to home")
        }
    };
    
    return {
        oncreate: () => {
            window.addEventListener('pageshow', handlePageShow);
            const navigationEntries = performance.getEntriesByType("navigation");
            if (navigationEntries.length > 0) {
                const navigationEntry = navigationEntries[0] as PerformanceNavigationTiming;
                if (navigationEntry.type === "back_forward") {
                    
                }
            }
        },
        onremove: () => {
            window.removeEventListener('pageshow', handlePageShow);
        },
        view(vnode) {
            let messageProvider = vnode.attrs.appContext.getMessageProvider();
            let langChangeActionItems = buildLanguageChangeActions(vnode.attrs.appContext);
            let { tentativeBooking } = vnode.attrs;

            return [
                m("div.app-layout",
                    [
                        m(NavBar, {
                            title: messageProvider.get("nav_title.make_payment"),
                            canBackPress: true,
                            onBackPressed: () => {
                                vnode.attrs.onBacktrackRequested();
                            },
                            actionItems: langChangeActionItems
                        }),

                        m("div.app-area-main", [
                            m(TentativeBookingSummary, {
                                operator: vnode.attrs.operator,
                                tentativeBooking: vnode.attrs.tentativeBooking,
                                messageProvider: messageProvider,
                                showTravellerInfoUpdateAction: false,
                                onTravellerInfoUpdateRequested: () => { }
                            }),

                            vnode.attrs.paymentOptions == null ?
                                m(LoadingIndicator)
                                :

                                [
                                    m(PaymentOptionSelectionList, {
                                        paymentOptions: vnode.attrs.paymentOptions,
                                        messageProvider: vnode.attrs.appContext.getMessageProvider(),
                                        onSelectPaymentOption: (paymentOption) => {
                                            vnode.attrs.onSelectPaymentOption(paymentOption)
                                        }
                                    }),
                                    vnode.attrs.selectedPayment != null ?
                                        m(SelectedPaymentModal, {
                                            appContext: vnode.attrs.appContext,
                                            isOpen: true,
                                            selectedPaymentOption: vnode.attrs.selectedPayment.paymentOption,
                                            promoAppliedResult: vnode.attrs.promoAppliedResult,
                                            showPromoCodeInvalidError: false,
                                            showLoading: vnode.attrs.isLoading,
                                            onApplyPromoCode: (promoCode: string) => {
                                                vnode.attrs.onApplyPromoCode(promoCode)
                                            },
                                            onRemovePromoCode: () => {
                                                vnode.attrs.onRemovePromoCode()
                                            },
                                            onSubmitPayment: () => {
                                                vnode.attrs.onInitiatePayment()
                                            },
                                            onClose: () => {
                                                vnode.attrs.onUnselectPaymentOption();
                                            }
                                        }) : null


                                ]


                        ]),


                        vnode.attrs.appContext.isLeavingExtraMarginBottom() ?
                            m("div.app-area-system-nav") : null
                    ]),
                m(ModalDialog, {
                    title: messageProvider.get("warning"),
                    message: tentativeBooking.trip.isSeatSelectionAllowed ? messageProvider.get("seat_will_lost") : messageProvider.get("filled_data_will_lost"),
                    shouldOpen: vnode.attrs.isBacktracking,
                    iconType: 'exclamation_circle',
                    iconThemeClass: " svg-medium svg-warning-dark-2",
                    onClosed: () => {
                        vnode.attrs.onBacktrackCancelled()
                    },

                    actionItems: [
                        {
                            label: "OK",
                            onclick: () => {
                                vnode.attrs.onBacktrackConfirmed()
                            }
                        },
                        {
                            label: "Cancel",
                            onclick: () => {
                                vnode.attrs.onBacktrackCancelled();
                            }
                        }

                    ]
                })
            ]
        }

    }
}

export default PaymentSelectionPage;